import { cn } from "@/utils/cn";
import { type AriaAttributes, memo } from "react";

interface FluidMarkProps {
    className?: string;
    "aria-hidden"?: AriaAttributes["aria-hidden"];
    "data-icon-size"?: "sm" | "lg" | "xl";
}

/**
 * FluidMark — Fluid's mark, the one AI icon: wherever the app shows AI at work, it loads Fluid's
 * mark image for the mode (--dw-fluid-mark-image, registry.css). The brand kit a browser wears (User
 * settings → Appearance → Brand images, one image for light mode and one for dark) replaces them
 * everywhere at once. Sized by dw-icon-box; a kit's image of any shape is contained in the same box.
 */
export const FluidMark = memo(function FluidMark({ className, ...rest }: FluidMarkProps) {
    return <span className={cn("dw-fluid-mark dw-icon-box", className)} aria-hidden data-component="FluidMark" data-location="src/components/ui/atoms/FluidMark.tsx" {...rest} />;
});
